import React, { Component } from 'react';

//components
import HtmlTextBlock from "../../../../../generic_components/components/text_display/HtmlTextBlock";
import CariMultiPositionPanel from "../../../components/cari_components/CariMultiPositionPanel";
import LoadingPgTemplate from "../../../../../generic_components/view/LoadingPgTemplate";
import CariMainPgLoggedInHeaderView from "../../cari_template_view/CariMainPgLoggedInHeaderView";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";

//generic functions
import {
    isEmpty,
    fetchCariOutageMessages
} from "../../../../../functions/generic_functions";

//get static routes
import {
    cari_api_load_outage_banner_url,
} from "../../../../../router/static_routes";

/*
    props:
        pageLoaded => conditional rendering upon api load
        staticUiData => the staticUiData json array that contains:
        {
            cariHomeDescrption: "description",
            positionList: [], //position list
        }
        selectPositionFunc => passed in function to set the active position
*/
class ContinuingPositionsHomeView extends Component {
    state = { outageMessages: [] }

    constructor(props) {
        super(props);
        this.loadOutageBannerFromApi = this.loadOutageBannerFromApi.bind(this);
    }

    loadOutageBannerFromApi() {
        fetchCariOutageMessages(cari_api_load_outage_banner_url).then((fetchedOutageMessages) => {
            this.setState({
                outageMessages: fetchedOutageMessages,
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    
    render() {
        return (
            <div>
                {this.props.pageLoaded ?
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12 layout_header_view">
                                <CariMainPgLoggedInHeaderView
                                    siteTitle={this.props.siteTitle}
                                    outageMessages={this.state.outageMessages}
                                /> 
                            </div>
                        </div> 
                        <br/><br/>
                        <div className="p-grid">
                            <div className="p-col-12 layout_left_right_padding continuing_home_height">
                                <label className="cari_title">
                                    Academic Recruitment Home
                                </label>
                                <br />
                                {(!isEmpty(this.props.staticUiData.cariHomeDescription)) ?
                                    <React.Fragment>
                                        <div className="p-grid">
                                            <div className="p-col-12">
                                                <HtmlTextBlock
                                                    text={this.props.staticUiData.cariHomeDescription}
                                                    className={"cari_small_text"}
                                                />
                                            </div>
                                        </div>

                                        <br />
                                        <br />
                                    </React.Fragment>
                                : null}
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <CariMultiPositionPanel
                                            positionList={this.props.staticUiData.positionList}
                                            selectPositionFunc={this.props.selectPositionFunc}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    : 
                    <LoadingPgTemplate/>
                }
                <CariMainPgFooterView />
            </div>
        );
    }
}

export default ContinuingPositionsHomeView;